import { render, staticRenderFns } from "./GameCategoryLobbyView.vue?vue&type=template&id=145aa474"
import script from "./GameCategoryLobbyView.vue?vue&type=script&lang=js"
export * from "./GameCategoryLobbyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('145aa474')) {
      api.createRecord('145aa474', component.options)
    } else {
      api.reload('145aa474', component.options)
    }
    module.hot.accept("./GameCategoryLobbyView.vue?vue&type=template&id=145aa474", function () {
      api.rerender('145aa474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lobbies/GameCategoryLobbyView.vue"
export default component.exports